import theme from './themeConfig.js'
import MainContainer from './components/layoutStructure/MainContainer'
import { CssBaseline } from '@mui/material'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import './i18n'
import { UserContextProvider } from './context/UserContextProvider.js'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useLocalizationProviderAdapterLocale, useMuiLocale } from './components/generic/hooks/useSmartTranslation/useSmartTranslation.jsx'
import { FrontEndConfigProvider } from './components/generic/hooks/useFrontEndConfig/useFrontEndConfig.js'
import { useMemo } from 'react'

function App () {
  const muiLocale = useMuiLocale()
  const createdTheme = useMemo(() => createTheme(theme, muiLocale), [muiLocale])

  return (
    <MUIThemeProvider theme={createdTheme}>
      <CssBaseline enableColorScheme />
      <UserContextProvider>
        <FrontEndConfigProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={useLocalizationProviderAdapterLocale()}>
            <MainContainer />
          </LocalizationProvider>
        </FrontEndConfigProvider>
      </UserContextProvider>
    </MUIThemeProvider>
  )
}

export default App
